import { Button } from '@chakra-ui/react';
import { BiTrash } from 'react-icons/bi';

import { Deal } from '../../gql/dealGql';
import { useReviveBootMutation } from '../../gql/generated/graphql';

type ReviveBootButtonProps = {
  duplicateDeals: Deal[];
  closeDuplicateModal: () => void;
};

const ReviveBootButton = ({ duplicateDeals, closeDuplicateModal }: ReviveBootButtonProps) => {
  const [reviveBoot, { loading }] = useReviveBootMutation();

  const handleClick = async () => {
    const bootedDeal = duplicateDeals[0];
    if (!bootedDeal.id) {
      return;
    }

    try {
      await reviveBoot({
        variables: {
          id: bootedDeal.id,
          reassign: true,
        },
      });

      // Open the link in a new tab after the mutation completes
      window.open(`/deals/${bootedDeal.id}`, '_blank', 'noopener,noreferrer');
      closeDuplicateModal();
    } catch (error) {
      console.error('Error reviving boot:', error);
    }
  };

  return (
    <Button
      variant="boot"
      size="lgWithIconLeft"
      leftIcon={<BiTrash />}
      onClick={handleClick}
      isLoading={loading}
    >
      Revive Boot
    </Button>
  );
};

export default ReviveBootButton;
